import BasePolicy from '@/policies/BasePolicy.js';

export default class EbookPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'can access system ebooks';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    manageScheduledReports(user) {
        return user.hasPermissionTo('manage ebook scheduled reports');
    }

    hasAdminAccess(user) {
        return user;
    }
}
